import React from "react";

import SimpleInput from "../input/SimpleInput";
import Button from "../button/Button";
import FORMS from "../constants/forms";
import PageTitle from "../pageTitle/PageTitle";

import { ContactFormProps } from "./types";
import styles from "./contactForm.module.css";

const SubmitButton = () => {
  return (
    <div className={styles.button}>
      <Button type="submit" text="Submit" />
    </div>
  );
};

const ContactForm = ({ handleContactForm }: ContactFormProps): JSX.Element => {
  const formData = {
    ...FORMS.CONTACT,
    handleSubmit: handleContactForm,
    submitButton: SubmitButton,
  };

  return (
    <div className={styles.container}>
      <div className={styles.titleContainer}>
        <div className={styles.title}>Contact</div>
      </div>
      <div className={styles.formContainer}>
        <SimpleInput
          data={formData}
          inputStyle="square"
          requiredFieldsLabel={true}
          reset
          data-netlify={true}
          //@ts-ignore
          name="Contact"
        />
      </div>
      <div className={styles.titleContainerBelow}>
        <div className={styles.title}>Whatsapp</div>
        <div className={styles.bodyText}>
          You can also get us on WhatsApp on 07930 656617
        </div>
      </div>
    </div>
  );
};

export default ContactForm;
